module.exports = "<img *ngIf=\"tenen\" src=\"{{url}}\" />\n<span *ngIf=\"!tenen\">:(</span>"